import { useAppDispatch, useAppSelector } from '@src/core/hooks';
import { cartStateSelector, setCartCoupon, removeCartCoupon } from '@src/features/cart/store/cart';
import { appInfoSelector } from '@src/stores/app';
import {
  computeCartDiscount,
  getCouponAffectedProductNames,
  canUseCoupon,
  type CartDiscount,
} from '@src/domains/coupons';

const EMPTY_DISCOUNT: CartDiscount = { fromCents: 0, toCents: 0, differenceCents: 0, percentage: 0 };

export function useCoupon() {
  const dispatch = useAppDispatch();
  const { cart, couponErrors, isLoadingCoupon } = useAppSelector(cartStateSelector);
  const appInfo = useAppSelector(appInfoSelector);

  const coupon = cart?.coupon;
  const discount = cart ? computeCartDiscount(cart) : EMPTY_DISCOUNT;
  const scope = getCouponAffectedProductNames(coupon, cart?.items ?? [], appInfo?.id);
  const canUse = canUseCoupon({
    hasCouponAvailable: appInfo?.hasCouponAvailable,
    appliedCouponCode: coupon?.code,
  });

  return {
    coupon,
    discount,
    scope,
    errors: couponErrors,
    isLoading: isLoadingCoupon,
    canUse,
    apply: (code: string) => dispatch(setCartCoupon(code)),
    remove: () => dispatch(removeCartCoupon()),
  };
}
